/**
 * Ruta `/dispositivo-no-registrado` (US3, T039): destino de `fermin:unauthenticated` y
 * `fermin:device-mismatch` (`__root.tsx`) y de Inicio cuando no hay credencial en este navegador.
 *
 * `?reason=session-expired` lo añade `routes/index.tsx` cuando `GET /me` respondió `401`: la
 * pantalla explica entonces que la sesión venció, en vez de dar a entender que el teléfono falla.
 * Cualquier otro valor se ignora (el puente de `__root.tsx` navega sin search). Sin `reason`, la
 * pantalla pide el código de traspaso y lo canjea como `/codigo` (piloto 2026-09-30).
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { NotRegisteredScreen } from '../features/access/not-registered';

import { useContinueAfterRedeem } from './codigo';

import { SESSION_EXPIRED_REASON } from './index';

export interface NotRegisteredSearch {
  reason?: typeof SESSION_EXPIRED_REASON;
}

export function NotRegisteredRoute() {
  const { reason } = Route.useSearch();
  const navigate = useNavigate();
  const onRedeemed = useContinueAfterRedeem();

  return (
    <NotRegisteredScreen
      sessionExpired={reason === SESSION_EXPIRED_REASON}
      onRedeemed={onRedeemed}
      onHasCode={() => void navigate({ to: '/codigo' })}
      onRequested={(ref) => void navigate({ to: '/solicitud/$ref', params: { ref } })}
      onViewStatus={(ref) => void navigate({ to: '/solicitud/$ref', params: { ref } })}
    />
  );
}

export const Route = createFileRoute('/dispositivo-no-registrado')({
  validateSearch: (search: Record<string, unknown>): NotRegisteredSearch =>
    search.reason === SESSION_EXPIRED_REASON ? { reason: SESSION_EXPIRED_REASON } : {},
  component: NotRegisteredRoute,
});
